export function toggleRateMatrixCellSelection(selection: string[], cellKey: string): string[] {
  return selection.includes(cellKey)
    ? selection.filter((key) => key !== cellKey)
    : [...selection, cellKey];
}
